// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Overlay ── */
.import-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 1rem;
}

/* ── Modal ── */
.import-modal {
  background: var(--logistik-blass);
  border-radius: 20px;
  padding: 2rem;
  width: 100%;
  max-width: 720px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.25);
}

.import-close {
  position: absolute;
  top: 1rem;
  right: 1.25rem;
  background: none !important;
  border: none;
  font-size: 1.2rem;
  color: #888;
  cursor: pointer;
  min-height: auto !important;
  padding: 0 !important;
  border-radius: 0 !important;
  line-height: 1;
}

.import-close:hover {
  color: #333;
  background: none !important;
}

.import-title {
  font-family: 'Staatliches', sans-serif;
  font-size: 2rem;
  color: var(--logistik);
  text-transform: uppercase;
  margin: 0 0 1.5rem 0;
  font-weight: normal;
}

/* ── Schritte ── */
.import-step {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  align-items: flex-start;
}

.import-step-num {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: var(--logistik);
  color: var(--weiss);
  font-family: 'Staatliches', sans-serif;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 0.1rem;
}

.import-step-body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.import-step-label {
  font-family: 'Staatliches', sans-serif;
  font-size: 1.15rem;
  color: #333;
  text-transform: uppercase;
}

/* ── Buttons ── */
.import-btn {
  display: inline-flex !important;
  align-items: center !important;
  gap: 0.4rem !important;
  padding: 0.55rem 1.1rem !important;
  border-radius: 20px !important;
  font-size: 1rem !important;
  min-height: auto !important;
  cursor: pointer;
  font-family: 'Staatliches', sans-serif !important;
  text-transform: uppercase !important;
  border: none;
  width: fit-content;
}

.import-btn .material-symbols-outlined {
  font-size: 1.1rem !important;
  color: inherit !important;
}

.download-btn {
  background: var(--logistik) !important;
  color: var(--weiss) !important;
}

.download-btn:hover {
  background: var(--logistik-hover) !important;
}

.import-confirm-btn {
  background: var(--logistik) !important;
  color: var(--weiss) !important;
}

.import-confirm-btn:hover:not(:disabled) {
  background: var(--logistik-hover) !important;
}

.import-confirm-btn:disabled {
  opacity: 0.6;
  cursor: default;
}

.import-cancel-btn {
  background: #e0e0e0 !important;
  color: #444 !important;
}

.import-cancel-btn:hover {
  background: #ccc !important;
}

.import-close-btn {
  background: var(--logistik) !important;
  color: var(--weiss) !important;
}

/* ── Dropzone ── */
.import-dropzone {
  border: 2px dashed var(--logistik-hell-hover);
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  background: white;
  color: #555;
  font-family: 'Circular', sans-serif;
  font-size: 0.95rem;
  transition: border-color 0.15s, background 0.15s;
}

.import-dropzone:hover {
  border-color: var(--logistik);
  background: var(--logistik-blass);
}

.drop-icon {
  font-size: 2rem !important;
  color: var(--logistik);
}

/* ── Fehler ── */
.import-fehler {
  background: #fdf0ee;
  border-left: 3px solid var(--blutorange);
  border-radius: 0 8px 8px 0;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  font-family: 'Circular', sans-serif;
  font-size: 0.88rem;
  color: var(--blutorange);
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

/* ── Vorschau-Tabelle ── */
.import-preview-wrapper {
  overflow-x: auto;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);
}

.import-preview-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  font-family: 'Circular', sans-serif;
  font-size: 0.82rem;
}

.import-preview-table th {
  background: var(--logistik);
  color: var(--weiss);
  padding: 0.4rem 0.65rem;
  text-align: left;
  font-family: 'Staatliches', sans-serif;
  font-size: 0.9rem;
  font-weight: normal;
  white-space: nowrap;
}

.import-preview-table td {
  padding: 0.35rem 0.65rem;
  border-bottom: 1px solid #eef2f2;
  color: #333;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.import-mehr {
  text-align: center;
  color: #888;
  font-style: italic;
  padding: 0.4rem !important;
}

.import-meta-note {
  background: var(--logistik-hell);
  border-radius: 8px;
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  font-size: 0.86rem;
  line-height: 1.35;
  padding: 0.55rem 0.7rem;
}

/* ── Ersetzen-Toggle ── */
.import-ersetzen-toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: 'Circular', sans-serif;
  font-size: 0.88rem;
  color: #555;
  cursor: pointer;
  margin-top: 0.25rem;
}

/* ── Import-Aktionen ── */
.import-actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-top: 0.25rem;
}

/* ── Erfolgsmeldung ── */
.import-erfolg {
  background: var(--logistik-success-bg);
  border-radius: 12px;
  padding: 1rem 1.25rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-family: 'Circular', sans-serif;
  color: var(--logistik-success);
  font-size: 1rem;
  flex-wrap: wrap;
}

.import-erfolg .material-symbols-outlined {
  color: var(--logistik-success);
  font-size: 1.5rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/logistik/ImportModal.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,sBAAsB;EACtB,kCAAkC;EAClC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;EACf,iDAAiD;EACjD,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,wCAAwC;EACxC,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;EACnC,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,sCAAsC;EACtC,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mCAAmC;EACnC,8BAA8B;EAC9B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B","sourcesContent":["/* ── Overlay ── */\n.import-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  padding: 1rem;\n}\n\n/* ── Modal ── */\n.import-modal {\n  background: var(--logistik-blass);\n  border-radius: 20px;\n  padding: 2rem;\n  width: 100%;\n  max-width: 720px;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.25);\n}\n\n.import-close {\n  position: absolute;\n  top: 1rem;\n  right: 1.25rem;\n  background: none !important;\n  border: none;\n  font-size: 1.2rem;\n  color: #888;\n  cursor: pointer;\n  min-height: auto !important;\n  padding: 0 !important;\n  border-radius: 0 !important;\n  line-height: 1;\n}\n\n.import-close:hover {\n  color: #333;\n  background: none !important;\n}\n\n.import-title {\n  font-family: 'Staatliches', sans-serif;\n  font-size: 2rem;\n  color: var(--logistik);\n  text-transform: uppercase;\n  margin: 0 0 1.5rem 0;\n  font-weight: normal;\n}\n\n/* ── Schritte ── */\n.import-step {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  align-items: flex-start;\n}\n\n.import-step-num {\n  width: 2rem;\n  height: 2rem;\n  border-radius: 50%;\n  background: var(--logistik);\n  color: var(--weiss);\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: 0.1rem;\n}\n\n.import-step-body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.import-step-label {\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.15rem;\n  color: #333;\n  text-transform: uppercase;\n}\n\n/* ── Buttons ── */\n.import-btn {\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 0.4rem !important;\n  padding: 0.55rem 1.1rem !important;\n  border-radius: 20px !important;\n  font-size: 1rem !important;\n  min-height: auto !important;\n  cursor: pointer;\n  font-family: 'Staatliches', sans-serif !important;\n  text-transform: uppercase !important;\n  border: none;\n  width: fit-content;\n}\n\n.import-btn .material-symbols-outlined {\n  font-size: 1.1rem !important;\n  color: inherit !important;\n}\n\n.download-btn {\n  background: var(--logistik) !important;\n  color: var(--weiss) !important;\n}\n\n.download-btn:hover {\n  background: var(--logistik-hover) !important;\n}\n\n.import-confirm-btn {\n  background: var(--logistik) !important;\n  color: var(--weiss) !important;\n}\n\n.import-confirm-btn:hover:not(:disabled) {\n  background: var(--logistik-hover) !important;\n}\n\n.import-confirm-btn:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.import-cancel-btn {\n  background: #e0e0e0 !important;\n  color: #444 !important;\n}\n\n.import-cancel-btn:hover {\n  background: #ccc !important;\n}\n\n.import-close-btn {\n  background: var(--logistik) !important;\n  color: var(--weiss) !important;\n}\n\n/* ── Dropzone ── */\n.import-dropzone {\n  border: 2px dashed var(--logistik-hell-hover);\n  border-radius: 12px;\n  padding: 1.25rem 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n  background: white;\n  color: #555;\n  font-family: 'Circular', sans-serif;\n  font-size: 0.95rem;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.import-dropzone:hover {\n  border-color: var(--logistik);\n  background: var(--logistik-blass);\n}\n\n.drop-icon {\n  font-size: 2rem !important;\n  color: var(--logistik);\n}\n\n/* ── Fehler ── */\n.import-fehler {\n  background: #fdf0ee;\n  border-left: 3px solid var(--blutorange);\n  border-radius: 0 8px 8px 0;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  font-family: 'Circular', sans-serif;\n  font-size: 0.88rem;\n  color: var(--blutorange);\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n/* ── Vorschau-Tabelle ── */\n.import-preview-wrapper {\n  overflow-x: auto;\n  border-radius: 10px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);\n}\n\n.import-preview-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  font-family: 'Circular', sans-serif;\n  font-size: 0.82rem;\n}\n\n.import-preview-table th {\n  background: var(--logistik);\n  color: var(--weiss);\n  padding: 0.4rem 0.65rem;\n  text-align: left;\n  font-family: 'Staatliches', sans-serif;\n  font-size: 0.9rem;\n  font-weight: normal;\n  white-space: nowrap;\n}\n\n.import-preview-table td {\n  padding: 0.35rem 0.65rem;\n  border-bottom: 1px solid #eef2f2;\n  color: #333;\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.import-mehr {\n  text-align: center;\n  color: #888;\n  font-style: italic;\n  padding: 0.4rem !important;\n}\n\n.import-meta-note {\n  background: var(--logistik-hell);\n  border-radius: 8px;\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.86rem;\n  line-height: 1.35;\n  padding: 0.55rem 0.7rem;\n}\n\n/* ── Ersetzen-Toggle ── */\n.import-ersetzen-toggle {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-family: 'Circular', sans-serif;\n  font-size: 0.88rem;\n  color: #555;\n  cursor: pointer;\n  margin-top: 0.25rem;\n}\n\n/* ── Import-Aktionen ── */\n.import-actions {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-top: 0.25rem;\n}\n\n/* ── Erfolgsmeldung ── */\n.import-erfolg {\n  background: var(--logistik-success-bg);\n  border-radius: 12px;\n  padding: 1rem 1.25rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-family: 'Circular', sans-serif;\n  color: var(--logistik-success);\n  font-size: 1rem;\n  flex-wrap: wrap;\n}\n\n.import-erfolg .material-symbols-outlined {\n  color: var(--logistik-success);\n  font-size: 1.5rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
